module.exports = __webpack_public_path__ + "img/bp_gift6.1fce8e42.png";